import React from 'react'

function MaterialAllDetails() {
  return (
    <div>MaterialAllDetails</div>
  )
}

export default MaterialAllDetails